import { render, staticRenderFns } from "./Sanctions.vue?vue&type=template&id=66ccbea1&scoped=true"
import script from "./Sanctions.vue?vue&type=script&lang=js"
export * from "./Sanctions.vue?vue&type=script&lang=js"
import style0 from "./Sanctions.vue?vue&type=style&index=0&id=66ccbea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ccbea1",
  null
  
)

export default component.exports